export const DEJANIRE = "dejanire";
export const MAHARAL = "maharal";
export const RASHOMON = "rashomon";
export const CETO = "ceto";
export const ALECTO = "alecto";
export const CAROLE = "carole";
export const KATRINA = "katrina";
export const TEKELI = "tekeli";
export const CAMILLA = "camilla";
export const GUEST = "???";

export const name = ({ character, t }) => t(`characters.${character}.name`);
